/**
 * Proxify setter function of given target object property.
 *
 * Note that a setter function is a function called on property
 * assignement.
 *
 * @param {*} target Target object.
 * @param {string} prop Property name.
 * @param {function} proxyFn The proxy function called each time setter function is executed.
 * @return {void}
 */
export function proxifySetter(target, prop, proxyFn) {
    const superProps = Object.getPrototypeOf(target);
    const superSet = Object.getOwnPropertyDescriptor(superProps, prop).set;
    const superGet = Object.getOwnPropertyDescriptor(superProps, prop).get;
    Object.defineProperty(target, prop, {
        get: function (...args) {
            return superGet.apply(this, args);
        },
        set: function (...args) {
            superSet.apply(this, args);
            proxyFn(...args);
        },
    });
}
